import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {ProcurementService} from "../../../services/procurement-service/procurement.service";
import {map} from "rxjs/operators";
import {ShoppingCart} from "../../../../shared/view-model/store-management/shopping-cart.type";
import {Observable} from "rxjs/Observable";

@Component({
  selector: 'vb-shopping-carts-overview-view',
  templateUrl: './shopping-carts-overview-view.component.html',
  styleUrls: ['./shopping-carts-overview-view.component.css']
})
export class ShoppingCartsOverviewViewComponent extends AbstractVisbosComponent implements OnInit {

  //TODO: Apollo
  private shoppingCartsPreview$: Observable<ShoppingCart[]>;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private procurementService: ProcurementService) {
    super(sessionActions, cd);
  }


  ngOnInit(): void {
    super.ngOnInit();
    this.shoppingCartsPreview$ = this.procurementService.prefetchShoppingCarts().pipe(
      map(res => res.data.shoppingCartsOverview)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/views/shopping-carts-overview-view/shopping-carts-overview-view.component.ts